import { ValidationResult } from './validation-result.model';

export function validateIsoDateTimeString(
  value: unknown,
  fieldName: string,
): ValidationResult {
  const errors: string[] = [];

  if (typeof value !== 'string' || value.trim() === '') {
    errors.push(`${fieldName} must be a non-empty ISO datetime string.`);
    return { isValid: false, errors };
  }

  if (!value.includes('T') || Number.isNaN(new Date(value).getTime())) {
    errors.push(`${fieldName} must be a valid ISO datetime string.`);
  }

  return { isValid: errors.length === 0, errors };
}

export function validateTimestampOrder(
  earlierValue: string,
  laterValue: string,
  earlierFieldName: string,
  laterFieldName: string,
): ValidationResult {
  const errors: string[] = [];
  const earlierDate = new Date(earlierValue);
  const laterDate = new Date(laterValue);

  if (Number.isNaN(earlierDate.getTime()) || Number.isNaN(laterDate.getTime())) {
    return { isValid: true, errors: [] };
  }

  if (laterDate.getTime() < earlierDate.getTime()) {
    errors.push(`${laterFieldName} cannot be earlier than ${earlierFieldName}.`);
  }

  return { isValid: errors.length === 0, errors };
}